import { Injectable, Inject} from '@angular/core';
import { SearchCriteriaDO } from './';

@Injectable()

 export class CriteriaIO {
  
    public page:any; 

    public size:any; 

    public  searchCriteriaList : SearchCriteriaDO[] = [];
    
    public getPage(){
        return this.page;
    }

    public setPage(page:any){
        this.page=page;
    } 
    public getSize(){
        return this.size;
    }
    public setSize(size:any){
        this.size=size;
    }
	public  getSearchCriteriaList() {
		return this.searchCriteriaList;
	}
	public  setSearchCriteriaList( searchCriteriaList:SearchCriteriaDO[]) {
		this.searchCriteriaList = searchCriteriaList;
	}
}
